import { AlertTriangle } from 'lucide-react';

import { Alert, AlertDescription } from '@/components/ui/alert';

interface ArchivedEntityAlertProps {
  /**
   * The localized message to display in the alert
   */
  message: string;
  /**
   * Additional CSS classes to apply to the alert
   */
  className?: string;
}

/**
 * Generic alert banner displayed at the top of archived entity pages.
 * Displays the provided localized message to inform users about the archived state.
 *
 * @example
 * // For archived projects
 * <ArchivedEntityAlert message={t('authenticated.projects:details.archivedProjectMessage')} />
 *
 * // For archived clients
 * <ArchivedEntityAlert message={t('authenticated.clients:details.archivedClientMessage')} />
 */
export function ArchivedEntityAlert({ message, className = 'mb-4' }: ArchivedEntityAlertProps) {
  return (
    <Alert variant="warning" className={className}>
      <AlertTriangle className="h-5 w-5" />
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}
